<template>
    <!-- 英语随材页面 -->
    <div>
        <DaanEn v-if="pageType === 'daan'"/>
        <AudioEn v-else/>
    </div>
</template>

<script lang="js">
import {Options, Vue} from 'vue-class-component';
import DaanEn from './components/daanEn.vue';
import AudioEn from './components/audioEn.vue';

@Options({
    components: {
        DaanEn,
        AudioEn
    },
    created() {
        const {type, level, id} = this.$route.query;
        this.pageType = type;
    }
})

export default class Content extends Vue {
    pageType = '';
}
</script>

<style lang="scss" scoped>
</style>
